
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import Hint from '../Hint.vue'

@Component({
  components: {
    Hint
  }
})
export default class HdsCheckboxCross extends Vue {
  @Prop({ default: false }) readonly value!: boolean
  @Prop({ default: false }) readOnly!: boolean
  @Prop({ default: false }) small!: boolean
  @Prop({ default: '' }) label!: string
  @Prop({ default: '' }) hintHtml!: string

  get isChecked() {
    return this.value
  }

  set isChecked(val: boolean) {
    this.$emit('input', val)
  }

  @Emit('change')
  emitChange(event: Event) {
    return (event.target as HTMLInputElement).checked
  }
}
